import { registerComponent, asyncRequest } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-summary",
  class ProductSummary extends WYATTElement {
    constructor() {
      super();

      this.endpoint = `${WYATT.routes.root}products/${this.dataset.handle}?view=summary`;

      this.getProductSummary();
    }

    get datasetClassTokens() {
      return (this.dataset.classList || "").trim().split(/\s+/).filter(Boolean);
    }

    get summaryCacheKey() {
      const handle = this.dataset.handle || "";
      const classes = [...this.datasetClassTokens].sort().join(" ");
      const tabindex = this.dataset.tabindex || "";
      return JSON.stringify([handle, classes, tabindex]);
    }

    async getProductSummary() {
      const cached = WYATT.searchspring.cached.products[this.summaryCacheKey];
      if (cached) {
        this.replaceWith(cached);
        return;
      }

      const response = await asyncRequest(this.endpoint);

      if (response) {
        this.handleSuccessfulUpdate(response);
      }
    }

    handleSuccessfulUpdate(html) {
      const productSummary = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".product-summary");
      if (this.datasetClassTokens.length) {
        productSummary.classList.add(...this.datasetClassTokens);
      }

      if (this.dataset.tabindex) {
        productSummary.querySelectorAll("button, a").forEach((element) => {
          element.setAttribute("tabindex", this.dataset.tabindex);
        });
      }

      WYATT.searchspring.cached.products[this.summaryCacheKey] = productSummary;

      this.replaceWith(productSummary);
    }
  },
);
